export default `
    id
    name
    order
    company
`;
